import { useParams } from 'react-router-dom';

export default function useDisputeParam() : string {   
    const { disputeId } = useParams();

    return disputeId as string;
}